import { currentBillingAddressStyles } from "@insite/content-library/Widgets/Addresses/CurrentBillingAddress";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(currentBillingAddressStyles, {
    gridContainer: {
        gap: 5,
        css: css`
            border-radius: 4px;
            padding: 10px;
            border: 2px solid #f1f6fb;
        `,
    },
    headingText: {
        css: css`
            font-size: 1rem;
            font-weight: 600;
        `,
    },
    editLinkGridItem: {
        width: 2,
        css: css`
            font-size: 1rem;
            justify-content: flex-end;
        `,
    },
});
